/* =================== CONTADORES =================== */
(function () {
  "use strict";

  const $container = $(".apresentacao");
  const $counters = $(".aps-contador-valor");
  const duration = 4000;

  if ($container.length > 0) {
    $counters.each(function () {
      const $el = $(this);
      const countTo = $el.attr("data-count");

      $({ countCur: 0 }).animate(
        { countCur: countTo },
        {
          duration: duration,
          easing: "swing",
          step: function () {
            $el.text(Math.floor(this.countCur));
          },
          complete: function () {
            $el.text(this.countCur);
          }
        }
      );
    });
  }
})();